module.exports = __webpack_public_path__ + "static/img/250redbag.201e171d.png";